import { p as prisma } from "../../../../chunks/prisma.js";
import { fail } from "@sveltejs/kit";
import { s as subscriptionPlanSchema } from "../../../../chunks/validationSchemas.js";
import { ZodError } from "zod";
const load = async () => {
  const plans = await prisma.subscriptionPlan.findMany({
    orderBy: { createdAt: "desc" }
  });
  const serializedPlans = plans.map((plan) => ({
    ...plan,
    price: Number(plan.price)
  }));
  return {
    plans: serializedPlans
  };
};
const actions = {
  savePlan: async ({ request }) => {
    const formData = await request.formData();
    const id = formData.get("id")?.toString();
    const rawData = {
      name: formData.get("name")?.toString() || "",
      description: formData.get("description")?.toString() || null,
      price: parseFloat(formData.get("price")?.toString() || "0"),
      duration: parseInt(formData.get("duration")?.toString() || "0", 10),
      isActive: formData.get("isActive") === "true"
    };
    try {
      const validatedData = subscriptionPlanSchema.parse(rawData);
      if (id) {
        await prisma.subscriptionPlan.update({
          where: { id: parseInt(id, 10) },
          data: validatedData
        });
      } else {
        await prisma.subscriptionPlan.create({ data: validatedData });
      }
      return {
        success: true,
        message: id ? "Plan updated successfully" : "Plan created successfully"
      };
    } catch (error) {
      if (error instanceof ZodError) {
        const errors = {};
        error.errors.forEach((err) => {
          const path = err.path[0];
          if (!errors[path]) errors[path] = [];
          errors[path].push(err.message);
        });
        return fail(400, { success: false, errors, data: rawData });
      }
      console.error("Database error:", error);
      return fail(500, {
        success: false,
        message: "Failed to save plan. Please try again.",
        data: rawData
      });
    }
  },
  deletePlan: async ({ request }) => {
    const formData = await request.formData();
    const id = formData.get("id")?.toString();
    if (!id) {
      return fail(400, { success: false, message: "Missing plan ID" });
    }
    try {
      const activeSubscriptions = await prisma.userSubscription.count({
        where: {
          planId: parseInt(id, 10),
          status: "ACTIVE"
        }
      });
      if (activeSubscriptions > 0) {
        return fail(400, {
          success: false,
          message: "Cannot delete plan with active subscriptions. Deactivate it instead."
        });
      }
      await prisma.subscriptionPlan.delete({
        where: { id: parseInt(id, 10) }
      });
      return { success: true, message: "Plan deleted successfully" };
    } catch (error) {
      console.error("Delete error:", error);
      return fail(500, { success: false, message: "Failed to delete plan" });
    }
  }
};
export {
  actions,
  load
};
